import React from "react"
import { BankName, Container, ContainerInfoHeader, DescriptionLabel, DescriptionText, HeaderContainer, InfoWrapper, Label, LabelHeader, Row, Subtitle, TopDivider, Value, ValueHeader } from "./styles"

interface PaymentDetailsProps {
  bankName?: string
  subtitle?: string
  description?: string
  originalValue?: number
  fineValue?: number
  taxValue?: number
  discountValue?: number
  totalValue: number
  plate?: string
  renavam?: string
}

export function ItemPaymentDetail({
  bankName = "BANCO CITIBANK S.A.",
  subtitle = "",
  description = "",
  originalValue,
  fineValue,
  taxValue,
  discountValue,
  totalValue,
  plate,
  renavam
}: PaymentDetailsProps) {
  const formatCurrency = (value: number) => {
    return value.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    })
  }

  return (
    <Container>
      <HeaderContainer>
        <BankName>{bankName}</BankName>
        <ContainerInfoHeader>
          {subtitle &&
            <Subtitle>{subtitle}</Subtitle>
          }
          {plate &&
            <InfoWrapper>
              <LabelHeader>Placa</LabelHeader>
              <ValueHeader>{plate}</ValueHeader>
            </InfoWrapper>
          }
          {renavam &&
            <InfoWrapper>
              <LabelHeader>Renavam</LabelHeader>
              <ValueHeader>Renavam</ValueHeader>
            </InfoWrapper>
          }
        </ContainerInfoHeader>
      </HeaderContainer>

      <TopDivider />

      {description && (<>
        <DescriptionLabel>Descrição</DescriptionLabel>
        <DescriptionText>{description}</DescriptionText>
      </>
      )}

      {!!originalValue && <Row>
        <Label>Valor original</Label>
        <Value>{formatCurrency(originalValue)}</Value>
      </Row>}

      {!!fineValue &&
        <Row>
          <Label>Valor da multa</Label>
          <Value>{formatCurrency(fineValue)}</Value>
        </Row>
      }

      {!!taxValue &&
        <Row>
          <Label>Valor da taxa</Label>
          <Value>{formatCurrency(taxValue)}</Value>
        </Row>
      }

      {!!discountValue &&
        <Row>
          <Label>Valor de desconto</Label>
          <Value>{formatCurrency(discountValue)}</Value>
        </Row>
      }

      <Row $isTotal>
        <Label $isTotal>Valor</Label>
        <Value $isTotal>{formatCurrency(totalValue)}</Value>
      </Row>
    </Container>
  )
}
